<template>
    <div style="height: 100%;width: 100%">
      <el-row>
        <el-col :span="6">
          <div class="center-down1">
            <div class="list-img">
              <img src="../../../assets/SHscreen/index_center_down_service_1.png">
            </div>
            <div class="list-text">
              <span>{{personcount}}</span>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="center-down2">
            <div class="list-img">
              <img src="../../../assets/SHscreen/index_center_down_family_2.png">
            </div>
            <div class="list-text">
              <span>{{familycount}}</span>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="center-down3">
            <div class="list-img">
              <img src="../../../assets/SHscreen/index_center_down_phlone_3.png">
            </div>
            <div class="list-text">
              <span>{{watchdevicecount}}</span>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="center-down4">
            <div class="list-img">
              <img src="../../../assets/SHscreen/index_center_down_equipment_4.png">
            </div>
            <div class="list-text">
              <span>{{gatewaydevicecount}}</span>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row style="font-size: 14px;text-align: center">
        <el-col :span="6">
          <span style="color: #2eef68">服务人数</span>
        </el-col>
        <el-col :span="6">
          <span style="color: #20a3f2">家庭数量</span>
        </el-col>
        <el-col :span="6">
          <span style="color: #34eb8f">移动设备数量</span>
        </el-col>
        <el-col :span="6">
          <span style="color: #fb9a13">居家设备数量</span>
        </el-col>
      </el-row>
    </div>
</template>

<script>
export default {
  name: 'indexCenterBottom',
  props: {
    bottomObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      personcount: 0,
      familycount: 0,
      gatewaydevicecount: 0,
      watchdevicecount: 0
    }
  },
  created () {
    this.personcount = this.bottomObj.personcount
    this.familycount = this.bottomObj.familycount
    this.gatewaydevicecount = this.bottomObj.gatewaydevicecount
    this.watchdevicecount = this.bottomObj.watchdevicecount
  },
  methods: {}
}
</script>

<style scoped>
.center-down1{
  width: 87px;
  height: 106px;
  margin: auto;
  background: url("../../../assets/SHscreen/index_center_down_1.png") no-repeat;
  background-size: 100% 100%;
}
.center-down2{
  width: 87px;
  height: 106px;
  margin: auto;
  background: url("../../../assets/SHscreen/index_center_down_2.png") no-repeat;
  background-size: 100% 100%;
}
.center-down3{
  width: 87px;
  height: 106px;
  margin: auto;
  background: url("../../../assets/SHscreen/index_center_down_3.png") no-repeat;
  background-size: 100% 100%;
}
.center-down4{
  width: 87px;
  height: 106px;
  margin: auto;
  background: url("../../../assets/SHscreen/index_center_down_4.png") no-repeat;
  background-size: 100% 100%;
}
.list-img{
  height: 56px;
  text-align: center;
}
.list-img img{
  width: 45px;
  margin-top: 13px;
}
  .list-text{
    height: 50px;
    color: white;
    font-size: 22px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/monitoring/bigComponents/indexCenterBottom.vue